module.exports = __webpack_public_path__ + "img/dropdown.f92ec519.svg";